module.exports = __webpack_public_path__ + "img/green-link-arrow-icon.28ec0e5c.svg";